const drawerWidth = 200;

export const useStyles = (theme) => ({
  root: {
    marginLeft: drawerWidth,
    padding: 30,
    marginTop: 50,
    backgroundColor: "#f9f9fc",
    [theme.breakpoints.down("md")]: {
      marginLeft: "auto",
      marginRight: "auto",
      padding: 20,
    },
  },
  paper: {
    width: "100%",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    height: "50vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    transition: `background 2s ease-in-out`,
    "&:hover": {
      background: "100%",
    },
  },
  loadingStyle: {
    height: "90vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});
